// extracted by mini-css-extract-plugin
module.exports = {"card":"StaffCard_card__1aSvz"};